export default __webpack_public_path__ + "static/media/alert_error_icon.3ee4bb74.svg";